enum UnauthBrowseLabTestsEntryPoint {
  PATIENT_SIGN_UP = "PatientSignUp",
  EMAIL_SENT = "EmailSent",
}

type UnauthEntryPoint = UnauthBrowseLabTestsEntryPoint;

export type { UnauthEntryPoint };

export { UnauthBrowseLabTestsEntryPoint };
